var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetflix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1311 9.71887L21.1963 11.5844C20.4773 10.8624 19.4255 9.77844 19.4255 9.77844L14.6817 9.94409L15.483 32.8901L18.2749 34.9006L21.1144 34.4545C21.1144 34.4545 21.0991 33.2543 21.0703 32.4282C22.0291 33.1418 23.3446 34.1365 23.3446 34.1365L27.966 33.5215L27.2093 11.8547L24.5957 9.59789L21.1311 9.71887ZM22.5322 27.6809L22.3732 27.7132L19.0738 10.4044L15.4493 10.531L16.2115 32.3577C16.2115 32.3577 16.9274 32.226 18.4409 32.013L17.7012 15.4154L17.8601 15.3831L21.0166 31.6562C21.0166 31.6562 21.8924 31.5189 24.8936 31.1206L24.164 10.2267L21.8454 10.3076L22.5322 27.6809Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0029 27.8063L21.8439 27.8385L18.6189 10.3671L15.1543 10.4881L15.924 32.528C15.924 32.528 16.6132 32.3972 18.0733 32.1861L17.3281 15.4286L17.487 15.3963L20.5425 31.833C20.5425 31.833 21.3916 31.6967 24.2596 31.303L23.5216 10.1692L21.3096 10.2464L22.0029 27.8063Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.4b43895e5fe455d5049de65e775dd966.svg";
export { ForwardRef as ReactComponent };